import { useEffect, useState } from "react";

export function useCapabilities() {
  const [caps, setCaps] = useState({ webgl: true, mobile: false, reducedMotion: false, checked: false });
  useEffect(() => {
    let webgl = true;
    try {
      const c = document.createElement("canvas");
      webgl = !!(window.WebGLRenderingContext && (c.getContext("webgl") || c.getContext("experimental-webgl")));
    } catch (e) { webgl = false; }
    const mobile = window.matchMedia("(max-width: 768px)").matches;
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    setCaps({ webgl, mobile, reducedMotion, checked: true });
  }, []);
  return caps;
}
